import {
  combineReducers
} from 'redux';
import initialState from '../../store/initialState';
import {
  UPDATE_PRODUCT_BY_BUTTON,
  UPDATE_PRODUCT_BY_DETAIL,
  UPDATE_PRODUCT_BY_FABRIC,
  UPDATE_PRODUCT_BY_CONTRAST,
  UPDATE_PRODUCT_BY_CONTRAST_TYPE,
  UPDATE_SELECTED_DETAIL,
  UPDATE_SELECTED_FABRIC,
  UPDATE_SELECTED_BUTTON,
  UPDATE_SELECTED_CONTRAST,
} from '../../constants/actionTypes';


const defaultFabric = initialState.general.updateProduct.selectedFabric;
const defaultDetails = initialState.general.updateProduct.selectedParts;
const defaultbuttons = initialState.general.updateProduct.selectedButtons;
const defaultSelectedAttrs = initialState.general.updateProduct.selectedAttr;


const selectedButtons = (state = defaultbuttons, action) => {
  if (action.type == UPDATE_SELECTED_BUTTON) {
    return action.data;
  }
  return state;
}


const selectedParts = (state = defaultDetails, {
  type,
  name,
  data,
  meta,
  payload,
}) => {
  const boolConverter = (val) => (
    typeof val === 'boolean' ? val :
    typeof val === 'string' && val.toLowerCase() === 'true' ? true : false
  )

  switch (type) {
    case UPDATE_SELECTED_DETAIL: {
      return {
        ...state,
        [name]: data
      }
    }

    case '@@redux-form/CHANGE': {
      if (!meta) {
        return { ...state };
      }
      if (meta.field === 'printProductNumber' && boolConverter(payload)) {
        return {
          ...state,
          embroideryFont: state.embroideryFont ? 
            state.embroideryFont : 
            {
              attrValue: 'Arial',
              objectId: '3a65431043025f9e7e7d9239a9978f2100000000',
              displayName: 'Arial',
              shortName: 'Arial',
              price: 0,
              discount: 0,
              sortPosition: 0
            },
          embroideryColor: state.embroideryColor ?
            state.embroideryColor : 
            {
              attrValue: '1000M',
              objectId: '#000000',
              displayName: 'Черный',
              shortName: 'Черный',
              price: 0,
              discount: 0,
              sortPosition: 0
            },
          embroidery: state.embroidery ? 
            state.embroidery : 
            {
              attrValue: 'embroideryAtCuff',
              objectId: '3c207d6f195027579ba02ccf043c696f00000000',
              displayName: 'На левой манжете',
              shortName: 'На левой манжете',
              price: 0,
              discount: 0,
              sortPosition: 1
            }
        }
      }
      if (meta.field === 'printProductNumber' && !boolConverter(payload)) {
        const {
          embroideryText,
          embroideryFont,
          embroideryColor,
          embroidery,
          printProductNumber,
          ...withoutEmbroidery
        } = state;

        return {
          ...withoutEmbroidery,
        }
      }

      if (meta.field === 'sleeveType' && payload == 'sleeveLong') {
        return {
          ...state,
          sleeve: {
            "attrValue": "sleeveLong",
            "displayName": "Длинный",
            "shortName": "Длинный",
          },
        }
      }

      if (meta.field === 'sleeveType' && payload == 'sleeveShort') {

        const {
          cuff,
          cuffStyle,
          cuffDensity,
          ...withoutCuff
        } = state;

        return {
          ...withoutCuff,
          sleeve: {
            "attrValue": "sleeveLong",
            "displayName": "Длинный",
            "shortName": "Длинный",
          },
        }
      }

      if ((meta.field === 'collarDensity' || meta.field === 'cuffDensity') &&
        payload == 'false') {
        const {
          [meta.field]: value,
          ...withoutCollarDensity
        } = state;

        return {
          ...withoutCollarDensity,
          [meta.field]: value,
        }
      }

      if (!Boolean(payload) || payload === 'false') {
        const { [meta.field]: value, ...withoutDelete } = state;
        return withoutDelete;
      }
    }

    default: {
      return state
    }
  }
}

const selectedContrasts = (state = defaultDetails, {
  type,
  data
}) => {
  switch (type) {
    case UPDATE_SELECTED_CONTRAST: {


      if (!data.value) {
        delete state[data.contrastKey];
        return { ...state };
      }

      return {
        ...state,
        [data.contrastKey]: data
      }
    }
    default: {
      return state
    }
  }
}

const selectedContrastsType = (state = null, {
  type,
  data
}) => {
  switch (type) {
    case 'CONTRAST_TYPE_CHANGED': {
      return data;
    }
    default: {
      return state
    }
  }
}

const shirtSceleton = (state = defaultDetails, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_BY_FABRIC:
    case UPDATE_PRODUCT_BY_BUTTON:
    case UPDATE_PRODUCT_BY_DETAIL:
    case UPDATE_PRODUCT_BY_CONTRAST:
      {
        return {
          ...state,
          [action.name]: action.value
        }
      }
    default: {
      return state
    }
  }
}

const selectedAttr = (state = defaultSelectedAttrs, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_BY_FABRIC:
    case UPDATE_PRODUCT_BY_BUTTON:
    case UPDATE_PRODUCT_BY_DETAIL:
    case UPDATE_PRODUCT_BY_CONTRAST: {
      return {
        attrName: action.name,
        attrValue: action.value,
      }
    }
    default:
      return state
  }
}



const selectedFabric = (state = defaultFabric, {
  type,
  data
}) => {
  switch (type) {
    case UPDATE_SELECTED_FABRIC: {
      return data;
    }
    default:
      return state
  }
}

const contrastSearchTerms = (state = '', {
  type,
  data
}) => {
  switch (type) {
    case 'UPDATE_CONTRAST_SEARCH_TERMS': {
      return data;
    }
    default:
      return state
  }
}



export default combineReducers({
  selectedButtons,
  selectedParts,
  shirtSceleton,
  selectedAttr,
  selectedFabric,
  selectedContrasts,
  selectedContrastsType,
  contrastSearchTerms,
})
